/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import { FETCH_FLEETBACK_PACK_SUCCESS } from 'constants/ActionTypes';

/**
 * @typedef {{
 *   fleetback: import("modules/global/typing/enums/pack.enum").FleetbackPackEnum[],
 * }} PackReducer
 */

const initialState = {
  fleetback: [],
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case FETCH_FLEETBACK_PACK_SUCCESS:
      draft.fleetback = action.pack;
      break;
    default:
  }
}, initialState);

export default reducer;
